import * as React from 'react'
import {FormControl, InputLabel, Select, MenuItem, Theme, createStyles, withStyles, WithStyles} from '@material-ui/core'
import {WithI18n, withI18n} from 'src/core/i18n/withI18n'
import {RootState} from 'src/core/redux/reducer/index'
import {compose} from 'redux'
import {connect} from 'react-redux'
import { fetchCategories } from 'src/core/redux/action/categoriesAction'
import { ICategory } from 'src/type/category'
import autobind from 'autobind-decorator'
import { slugify, convertSlugToName } from 'src/shared/utils/helpers'

const styles = (t: Theme) => createStyles({
    formControl: {
        margin: `${t.spacing.unit}px 0`,
        width: '100%'
    },
    chips: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    chip: {
        margin: t.spacing.unit / 4,
    },
    noLabel: {
        marginTop: t.spacing.unit * 3,
    },
    parents: {
        fontWeight: 'bold',
        color: t.palette.primary.main,
        opacity: 1
    },
    child: {
        paddingLeft: '24px'
    }
});

interface IProps extends WithI18n,
  WithStyles<typeof styles>,
  ReturnType<typeof state2props>,
  ReturnType<typeof dispatch2props>  {
  dispatch: any;
  categoriesDispo: any;
  input: any;
  label: string;
  callback?: any;
}


interface IStates {
  categoriesSelected: any;
}


class CategoriesKycSelect extends React.Component<IProps & ReturnType<typeof dispatch2props>, IStates> {
  state = {
    categoriesSelected: this.props.input.value ? this.props.input.value : [],
  };

  componentDidMount(){
    this.props.fetch().then(res => {
        res.map(c => c.sub_categories.sort((a, b) => a.localeCompare(b)))
        this.setState({categoriesSelected: this.props.input.value ? this.changeSlugToName(this.props.input.value) : []})
    });
  }

  render() {
    const {categories, classes, label} = this.props
    return (
      <>
          {categories &&
             <FormControl className={classes.formControl}>
                <InputLabel htmlFor="select-multiple-chip">{label}</InputLabel>
                <Select
                    value={this.state.categoriesSelected}
                    onChange={this.handleChange}
                    fullWidth={true}
                >
                    {this.buildCategories(categories).map(c => 
                        <MenuItem 
                            key={c.slug} 
                            value={c.slug} 
                            disabled={c.lv === 1 ? true : false} 
                            className={c.lv === 1 ? classes.parents : classes.child}
                        >
                            <span>{c.name}</span>
                        </MenuItem>
                    )}
                </Select>
            </FormControl>
          }

      </>
    )
  }

  /*
    When editing News, the categories from News is a list of slug, 
    so we need to convert to list of name to adapte with component Select
    Exp: ["pme", "hebdo", "points", ...] => ["PME", "Hebdo", "Points", ...] 
  */
  private changeSlugToName(arrCate: any){
    const {categoriesDispo, categories} = this.props
    return convertSlugToName(categoriesDispo, categories, arrCate);
  }

  /*
    Rebuid list categories from API to list categories for component Select,
    push category and sub category into a same array then add attribute lv 
  */
  private buildCategories(categories: ICategory[]){
    const {categoriesDispo} = this.props
    const build:any[] = [];
    if(categoriesDispo === 'all'){
        categories.map(category => {
            this.buildCategory(category, build)
        })
    } else{
        categories.map(category => {
            if(categoriesDispo.includes(category.slug)){
                this.buildCategory(category, build)
            }
        })
    }
    return build;
  }

  private buildCategory(category: ICategory, build:any[]){
    build.push({
        lv: 1,
        name: category.name,
        slug: category.slug,
        color: category.background_color
    })
    if(category.sub_categories.length > 0){
        category.sub_categories.map(subCategory => {
            build.push({
                lv: 2,
                name: subCategory,
                slug: slugify(subCategory),
                group: category.slug,
                color: '#000000'
            })
        })
    }
  }

  @autobind
  private handleChange(event: any) {
    if(this.props.callback) this.props.callback(event.target.value)  // dirty thing to satisfy client
    this.setState({ categoriesSelected: event.target.value });
    this.props.input.onChange(event.target.value);
  };

}

const state2props = (state: RootState) => ({
  categories: state.categories.entities,
})

const dispatch2props = (dispatch: any) => ({
    fetch: () => dispatch(fetchCategories()),
})

export default compose(
  withI18n,
  withStyles(styles),
  connect(state2props, dispatch2props),
)(CategoriesKycSelect)



// WEBPACK FOOTER //
// ./src/shared/CategoriesSelect/CategoriesKycSelect.tsx